module.exports = __webpack_public_path__ + "static/2bdigital-b1d942de869bea9215ab75fb1db5f719.jpg";